import React, { FC } from 'react';

import { IconButton, IconButtonProps } from '@chakra-ui/react';
import { colorOpacity, customTheme } from 'theme';

import { ArrowDownIcon, ArrowUpIcon } from 'components/Icons';

interface ArrowIconButtonProps extends Omit<IconButtonProps, 'icon'> {
  direction: 'up' | 'down';
}

export const ArrowIconButton: FC<ArrowIconButtonProps> = props => {
  const { direction, ...rest } = props;

  return (
    <IconButton
      icon={direction === 'up' ? <ArrowUpIcon /> : <ArrowDownIcon />}
      boxSize={8}
      minW={8}
      p={1}
      borderRadius="full"
      bg={colorOpacity(customTheme.colors.primary, 0.1)}
      color="primary"
      _hover={{ bg: 'primary', color: 'white' }}
      _active={{ bg: 'primary', color: 'white' }}
      _focus={{ bg: 'primary', color: 'white' }}
      _disabled={{ opacity: 0.4, cursor: 'not-allowed' }}
      {...rest}
    />
  );
};
